module.exports = __webpack_public_path__ + "static/img/t53.8c670133.png";